var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M899.5 432.2v258.4c0 49.9-37 89.5-81.6 89.5H205.3c-44.6 0-81.6-39.6-81.6-89.5V213.2c0-49.9 37-89.5 81.6-89.5h621.2c29.2 0 55.7 19.2 67.1 48.8 3.7 10.1 12.6 17.5 23.3 19.2 10.7 1.7 21.4-2.5 28.1-10.9 6.7-8.5 8.3-19.9 4.2-29.9C929 99 881 64 826.5 64H205.3C126.8 64 64 131.3 64 213.2v477.4c0 81.9 62.8 149.2 141.3 149.2h612.6c78.5 0 141.3-67.3 141.3-149.2V432.2c0-16.5-13.4-29.8-29.8-29.8s-29.9 13.3-29.9 29.8z"
      }
    }), _c('path', {
      attrs: {
        "d": "M374.5 624.1c3.2 12.1 13.7 21 26.2 22.1 12.5 1.1 24.4-5.7 29.7-17L538.8 398 619 498c5.3 6.6 13.2 10.7 21.7 11.1 8.5.5 16.8-2.7 22.8-8.8l159.8-161.2c7.7-7.5 10.8-18.6 8-29-2.8-10.4-11-18.5-21.4-21.2-10.4-2.7-21.5.5-29 8.2L644.6 434.6l-89.3-111.2c-6.4-8-16.6-12.2-26.8-11s-19.1 7.6-23.5 17l-93.8 200.1-29.1-110.6c-2.6-9.9-10.1-17.8-19.9-20.9-9.8-3.1-20.5-.9-28.3 5.7L186 528.9c-12.1 10.8-13.5 29.2-3 41.6 10.5 12.4 28.9 14.1 41.5 3.9l111.9-94.7 38.1 144.4zm-77.7 328.2h413.8c17.5 0 31.8-13.4 31.8-29.8 0-16.5-14.3-29.8-31.8-29.8H296.8c-17.5 0-31.8 13.4-31.8 29.8s14.3 29.8 31.8 29.8z"
      }
    })]));
  }
};